import React, { useCallback, useContext } from 'react';
import * as UI from './styles';
import logo from '../../assets/icons/logo.svg';
import logoGreen from '../../assets/icons/logo_green.svg';
import { ThemeContext } from 'styled-components';
import Divider from '../Divider';
import MenuItem from '../MenuItem';
import AppThemeContext from '../../contexts/theme';
import { useAuth } from '../../contexts/auth';
import physics from '../../styles/themes/physics';
import chemistry from '../../styles/themes/chemistry';
import { useCourse } from '../../contexts/course';
import { CourseType } from '../../contracts/enums';
import { local } from '../../storage';
import { URI } from '../../contracts/enums'
import { TypeIcons } from '../Icon';

function SideBar() {
  const { colors } = useContext(ThemeContext);
  const {
    theme: { title },
  } = useContext(AppThemeContext);

  const { changeTheme } = useContext(AppThemeContext);
  const { user } = useAuth();
  const { setTypeCourse: setType } = useCourse();

  const toggleTheme = useCallback((title: CourseType) => {
    changeTheme(title === CourseType.physics ? physics : chemistry);
    setType(title);
  }, [changeTheme, setType]);

  return (
    <UI.Container logged={!!user} >
      <UI.Logo src={title === CourseType.physics ? logo : logoGreen} />

      <UI.ThemeSwitcher>
        <UI.ChemistryButton
          onClick={() => toggleTheme(CourseType.chemistry)}
          _bgColor={title === CourseType.chemistry ? colors.primary : 'transparent'}
          _hoverColor={
            title === CourseType.chemistry ? colors.primary : colors.secondary
          }
          _textColor={title === CourseType.chemistry ? colors.white : colors.dark_grey}
        >
          Química
        </UI.ChemistryButton>

        <UI.PhysicsButton
          onClick={() => toggleTheme(CourseType.physics)}
          _bgColor={title === CourseType.physics ? colors.primary : 'transparent'}
          _hoverColor={title === CourseType.physics ? colors.primary : colors.secondary}
          _textColor={title === CourseType.physics ? colors.white : colors.dark_grey}
        >
          Física
        </UI.PhysicsButton>
      </UI.ThemeSwitcher>

      <Divider w={18} />

      <UI.Menu>
        <MenuItem link={URI.dashboard} icon={TypeIcons.home} label="Dashboard" />
        <MenuItem link={URI.lessons.replace('/:id', '')} icon={TypeIcons.lesson} label="Aulas" />
        <MenuItem link={URI.exams} icon={TypeIcons.exam} label="Provas" />
        <MenuItem icon={TypeIcons.analytics} label="Estatísticas" isSoon={true} />
        <MenuItem link={URI.clinicalCase} icon={TypeIcons.tutoring} label="Casos Clínicos" />
        <MenuItem link={URI.monitoria} icon={TypeIcons.monitoring} label="Monitorias" />
        <MenuItem
          icon={TypeIcons.material}
          label="Material digital"
          isAccordion
          submenus={[
            {
              label: 'Apostilas',
              link: URI.handout
            },
            {
              label: 'Simulados',
              link: URI.longExam
            },
            {
              label: 'Resoluções provas',
              link: URI.examResolution
            },
            {
              label: 'Resoluções apostila',
              link: URI.handoutResolution,
            },
            {
              label: 'Resoluções simulados',
              link: URI.longExamResolution
            },
            {
              label: 'Aulas Extras',
              link: URI.extraLessons
            },
            {
              label: 'Conteúdos Extras',
              link: URI.extraContent
            },
          ]}
        />
      </UI.Menu>

      <Divider w={18} />

      <UI.MenuConfig>
        <MenuItem icon={TypeIcons.profile} isSoon={true} label="Perfil" />
        <MenuItem icon={TypeIcons.logout} link={URI.base} handle={() => { local.removeAll(); window.location.reload() }} label="Sair" />
      </UI.MenuConfig>
    </UI.Container>
  );
}

export default SideBar;
